<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-bottom:40px;">Dedication</h1>
<p>I would like to dedicate <em>The Mastery of Life</em> to my daughter, Anna, for her unreserved support and understanding during the time I have worked on this book. I would also like to thank my dad for his support and for his wisdom, which he has shared with me relentlessly over the years. Lastly, I would like to thank my sister, Tania, for her guidance regarding some aspects of this book and the same applies to my good friends: Andrew and Richard. I would like to thank you all for all your support, love and understanding—it’s all very much appreciated.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?97321c0c